package co.uk.paxes.pinpoint

object DebugLogger {
    var enabled = false

    fun d(tag: String, message: String) {
        if (enabled) println("DEBUG/$tag: $message")
    }

    fun i(tag: String, message: String) {
        if (enabled) println("INFO/$tag: $message")
    }

    fun e(tag: String, message: String, t: Throwable? = null) {
        if (enabled) {
            println("ERROR/$tag: $message")
            t?.printStackTrace()
        }
    }
}
